import api from "@/lib/api";

const DB = "cs-entregas";
const STORE = "cola";

const open = () => new Promise((res, rej) => {
  const r = indexedDB.open(DB, 1);
  r.onupgradeneeded = () => r.result.createObjectStore(STORE, { keyPath: "entregaId" });
  r.onsuccess = () => res(r.result);
  r.onerror = () => rej(r.error);
});

const tx = async (mode, fn) => {
  const db = await open();
  return new Promise((res, rej) => {
    const t = db.transaction(STORE, mode);
    const out = fn(t.objectStore(STORE));
    t.oncomplete = () => res(out?.result ?? out);
    t.onerror = () => rej(t.error);
  });
};

export const listarCola = () => tx("readonly", (s) => s.getAll());
const guardar = (item) => tx("readwrite", (s) => s.put(item));
const borrar = (id) => tx("readwrite", (s) => s.delete(id));

export const encolarEntrega = (entregaId, files, payload) =>
  guardar({ entregaId, payload, files: files.map((f) => ({ name: f.name, type: f.type, blob: f, subido: false })), createdAt: Date.now() });

const esRed = (err) => !err?.response;

let corriendo = false;
export async function procesarCola() {
  if (corriendo) return { pendientes: (await listarCola()).length };
  corriendo = true;
  const resultados = [];
  try {
    for (const item of await listarCola()) {
      try {
        if (!item.limpio) {
          try { await api.delete(`/viajes/entregas/${item.entregaId}/archivos`); }
          catch (err) { if (err?.response?.status !== 409) throw err; }
          item.limpio = true;
          await guardar(item);
        }
        for (const f of item.files) {
          if (f.subido) continue;
          const fd = new FormData();
          fd.append("file", new File([f.blob], f.name, { type: f.type }));
          try { await api.post(`/viajes/entregas/${item.entregaId}/archivo`, fd); }
          catch (err) { if (err?.response?.status !== 409) throw err; }
          f.subido = true;
          await guardar(item);
        }
        try { await api.post(`/viajes/entregas/${item.entregaId}/confirmar`, item.payload); }
        catch (err) { if (err?.response?.status !== 409) throw err; }
        await borrar(item.entregaId);
        resultados.push({ entregaId: item.entregaId, ok: true });
      } catch (err) {
        if (esRed(err)) break;
        await borrar(item.entregaId);
        resultados.push({ entregaId: item.entregaId, ok: false, error: err?.response?.data?.detail || err.message });
      }
    }
  } finally { corriendo = false; }
  return { resultados, pendientes: (await listarCola()).length };
}
